import { useSelector } from "@xstate/store-react";
import { panelStore } from "@/app/providers/panel-store";

export const useAgentPanelOpen = () => useSelector(panelStore, (s) => s.context.activePanel === "agent");

export const useAgentPanelActions = () => ({
  togglePanel: () => panelStore.send({ type: "panel.toggle", panel: "agent" }),
  closePanel: () => panelStore.send({ type: "panel.close" }),
});
